import { render } from "./FeedView.vue?vue&type=template&id=2c4e9afe"
import script from "./FeedView.vue?vue&type=script&lang=js"
export * from "./FeedView.vue?vue&type=script&lang=js"

import "./FeedView.vue?vue&type=style&index=0&id=2c4e9afe&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__